import { render, staticRenderFns } from "./GuestbookAdmin.vue?vue&type=template&id=222e39ba"
import script from "./GuestbookAdmin.vue?vue&type=script&lang=js"
export * from "./GuestbookAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports